import ProductHelper from "./Product";

const FormHelper = {
  initialValues: (fieldNames, values) => {
    const initialValues = {};

    for (let i = 0; i < fieldNames.length; i++) {
      initialValues[fieldNames[i]] = "";

      if (["files", "classifications"].includes(fieldNames[i])) {
        initialValues[fieldNames[i]] = [];
      }

      if (fieldNames[i] === "address") {
        initialValues[fieldNames[i]] = {
          country_id: 244,
          line1: "",
          line2: "",
          postal_code: "",
          locality: "",
          region: "",
        };
      }

      if (fieldNames[i] === "internal_product") {
        initialValues[fieldNames[i]] = "owned";
      }

      // Marketplace descriptions default from the store's OWN marketplace
      // account (set in RCListingForm), not a hardcoded brand default — blank here.
      if (fieldNames[i] === "chrono_description") {
        initialValues[fieldNames[i]] = "";
      }

      if (fieldNames[i] === "ebay_description") {
        initialValues[fieldNames[i]] = "";
      }

      if (fieldNames[i] === "ebay_price") {
        // Default eBay price for a new listing: £100 expressed in GBP (major
        // units). This field is GBP-denominated in the form — divided by 100 on
        // load and multiplied by 100 on submit — so this literal is pounds, not
        // pence. Do NOT change it to 10000.
        initialValues[fieldNames[i]] = 100;
      }

      if (fieldNames[i] === "ebay_handling_time") {
        initialValues[fieldNames[i]] = 1;
      }

      if (fieldNames[i] === "tax_rate") {
        initialValues[fieldNames[i]] = values?.[fieldNames[i]] === "vat";
        continue;
      }

      // listings.chrono_certified is NOT NULL DEFAULT true server-side, so a new
      // listing must start ON — the blank "" default below becomes null via
      // ConvertEmptyStringsToNull and the insert dies with SQLSTATE 23000 (1048).
      //
      // `continue` is load-bearing: the hydration test at the bottom of this loop
      // is `if (values && values[field])`, a TRUTHY check. A stored `false`/`0`
      // fails it, so without bypassing it an already-uncertified listing would
      // re-hydrate as ON and silently be saved back as certified. Use `??` so
      // only a genuinely absent value falls back to the default.
      if (fieldNames[i] === "chrono_certified") {
        initialValues[fieldNames[i]] = values?.[fieldNames[i]] ?? true;
        continue;
      }

      if (fieldNames[i] === "store_url") {
        if (values?.store) {
          initialValues[fieldNames[i]] = values.store?.store_url;
        }
      }

      if (fieldNames[i] === "shopify_url") {
        if (values?.store) {
          initialValues[fieldNames[i]] = values.store?.shopify_url;
        }
      }

      if (values && values[fieldNames[i]]) {
        let value = values[fieldNames[i]];

        if (
          fieldNames[i] === "buying_price" ||
          fieldNames[i] === "price" ||
          fieldNames[i] === "chrono_price" ||
          fieldNames[i] === "ebay_price" ||
          fieldNames[i] === "wf_price" ||
          fieldNames[i] === "polishing" ||
          fieldNames[i] === "accessories" ||
          fieldNames[i] === "shipping" ||
          fieldNames[i] === "travel"
        ) {
          value = values[fieldNames[i]] / 100;
        }

        initialValues[fieldNames[i]] = value;
      }
    }

    return initialValues;
  },
};

export default FormHelper;
